import React from "react";
import styled from "styled-components";
import { GATSBY_URL } from "../config";

const FooterWrapper = styled.footer`
  width: 100%;
  background: ${(props) => props.theme.primaryBlue};
  padding: 5rem 0;
  .inner {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 5rem;
    @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
      width: ${(props) => props.theme.contentWidth.tablet};
      padding: 0;
    }
    @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
      width: ${(props) => props.theme.contentWidth.mobile};
    }
  }
  .contentGrid {
    display: grid;
    grid-template-columns: auto 12rem 300px;
    grid-column-gap: 2.5rem;
    color: white;
    font-size: 18px;
    line-height: 2rem;
    @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
      display: block;
      width: ${(props) => props.theme.contentWidth.tablet};
      padding: 0;
    }
    @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
      width: ${(props) => props.theme.contentWidth.mobile};
    }
    p {
      margin: 0;
    }
  }
  .title {
    font-size: 14px;
    color: #d6d6d6;
  }
  .about,
  .menu,
  .contact {
    @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
      margin-bottom: 4rem;
    }
  }
  .logo {
    display: flex;
    align-items: center;
    color: black;
    font-size: 2rem;
    margin: 1rem 0;
    @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
      font-size: 24px;
    }
  }
  a {
    text-decoration: none;
    color: white;
  }
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <div className="inner">
        <div className="contentGrid">
          <div className="about">
            <div className="title">ABOUT</div>
            <div className="logo">The New Era of Health</div>
            <p>
              Adam Lucero is a total human optimization expert. He has spent
              years of his life studying how our ancestors lived, how humans
              have evolved and more importantly what foods and exercises will
              change you on a cellular level so that you feel, think, look &
              perform like a greek conqueror!
            </p>
          </div>
          <div className="menu">
            <div className="title">MENU</div>
            <div>
              <a href={`${GATSBY_URL}/`}>Home</a>
            </div>
            <div>
              <a href="https://alenterprises.lpages.co/fgc3">Program</a>
            </div>
            <div>
              <a href={`https://store.theneweraofhealth.com/`}>Store</a>
            </div>
            <div>
              <a href={`${GATSBY_URL}/aboutus`}>About Us</a>
            </div>
            <div>
              <a href={`${GATSBY_URL}/`}>Blog</a>
            </div>
          </div>
          <div className="contact">
            <div className="title">CONTACT</div>
            <div>
              <p>General Questions</p>
              <p>
                <a href="mailto:adam@theneweraofhealth.com">
                  Adam@TheNewEraOfHealth.com
                </a>
              </p>
              <p>Call Or Text Adam</p>
              <p>
                <a href="tel:8053000674">(805) 300-0674</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </FooterWrapper>
  );
};

export default Footer;
